import type { AIModel, ModelTierDefault } from "@/types";

const TIER_PREFIX = "tier:";
const CHOOSE_FOR_ME = `${TIER_PREFIX}router`;

interface ResolveDefaultModelIdInput {
  preferredModelId?: string | null;
  tierDefaults: ModelTierDefault[];
  enabledModels: AIModel[];
}

function isSelectable(value: string | null | undefined, tierDefaults: ModelTierDefault[], enabledModels: AIModel[]) {
  if (!value) return false;
  if (value.startsWith(TIER_PREFIX)) {
    const tier = value.slice(TIER_PREFIX.length);
    return tierDefaults.some((td) => td.tier === tier && td.modelId);
  }
  return enabledModels.some((m) => m.id === value);
}

export function resolveDefaultModelId({
  preferredModelId,
  tierDefaults,
  enabledModels,
}: ResolveDefaultModelIdInput): string | null {
  const match = [preferredModelId, CHOOSE_FOR_ME].find((value) => isSelectable(value, tierDefaults, enabledModels));
  return match ?? enabledModels[0]?.id ?? null;
}
